import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=610645ad&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=610645ad&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports